import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { Handshake } from 'lucide-react'
import { fadeInUp, viewportOnce } from '../../utils/animations'

export default function CommunityPartnershipsHero() {
  const { t } = useTranslation()

  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeInUp}
      className="-mt-4 mb-10 overflow-hidden rounded-3xl border border-primary/10 bg-gradient-to-br from-primary/5 via-white to-accent/5 p-8 text-center sm:p-10"
    >
      <div className="mx-auto flex max-w-3xl flex-col items-center">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl gradient-brand">
          <Handshake className="h-7 w-7 text-white" />
        </div>
        <p className="mb-3 text-xs font-bold uppercase tracking-widest text-accent">
          {t('communityPartnerships.heroLabel')}
        </p>
        <h2 className="text-2xl font-bold text-primary sm:text-3xl">
          {t('communityPartnerships.heroTitle')}
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-text/70">
          {t('communityPartnerships.heroText')}
        </p>
      </div>
    </motion.section>
  )
}
